// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Voice-call UI — clean, WhatsApp-style call screen. Own stylesheet (imported by
 * CallScreen) so it hot-reloads cleanly in dev and stays self-contained. Dark,
 * neutral surface with the layout: name → "audio call" subtitle → round photo →
 * red/green actions at the bottom. Reads well over any app theme.
 */

/* ── Light backdrop; the call window floats in the TOP-RIGHT (WhatsApp) ── */
.cs-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 1.1rem 1.1rem 0 0;
  background: rgba(7, 12, 15, 0.32);
  animation: csFadeIn 0.22s ease-out;
}

/* The floating card itself — compact WhatsApp-style call window, top-right. */
.cs-window {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: min(90vw, 336px);
  min-height: 440px;
  padding: 2rem 1.25rem 1.75rem;
  border-radius: 22px;
  color: #ffffff;
  background:
    radial-gradient(480px 340px at 50% 16%, rgba(37, 211, 102, 0.12), transparent 62%),
    linear-gradient(180deg, #2a3942 0%, #131f26 52%, #0b141a 100%);
  box-shadow:
    0 24px 60px rgba(0, 0, 0, 0.55),
    0 0 0 1px rgba(255, 255, 255, 0.06);
  overflow: hidden;
  animation: csWindowIn 0.26s cubic-bezier(0.22, 0.61, 0.36, 1);
}

.cs-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.55rem;
  text-align: center;
  padding: 0 0.5rem;
}

/* ── Name + subtitle (above the photo, WhatsApp order) ────────────────── */
.cs-name {
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: 0.2px;
  line-height: 1.25;
  color: #ffffff;
  max-width: 100%;
}

.cs-status {
  font-size: 0.9rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.62);
  min-height: 1.3em;
  margin-bottom: 1.1rem;
}

.cs-timer {
  font-variant-numeric: tabular-nums;
  letter-spacing: 1px;
  color: rgba(255, 255, 255, 0.85);
}

/* Animated "…" for ringing/connecting states. */
.cs-dots::after {
  content: '';
  animation: csDots 1.4s steps(4, end) infinite;
}

/* ── Avatar + soft pulse ──────────────────────────────────────────────── */
.cs-avatar-wrap {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 112px;
  height: 112px;
  margin-top: 0.25rem;
}

.cs-ring {
  position: absolute;
  width: 112px;
  height: 112px;
  border-radius: 50%;
  border: 1.5px solid rgba(37, 211, 102, 0.5);
  opacity: 0;
  pointer-events: none;
}
.cs-avatar-wrap.is-ringing .cs-ring {
  animation: csRingPulse 2.6s cubic-bezier(0.22, 0.61, 0.36, 1) infinite;
}
.cs-avatar-wrap.is-ringing .cs-ring:nth-child(2) { animation-delay: 0.9s; }
.cs-avatar-wrap.is-ringing .cs-ring:nth-child(3) { animation-delay: 1.8s; }
/* Connected: a single calm breathing halo. */
.cs-avatar-wrap.is-connected .cs-ring:first-child {
  opacity: 1;
  border-color: rgba(255, 255, 255, 0.16);
  animation: csBreathe 3.6s ease-in-out infinite;
}

/* Speaking: energetic green waves ripple outward + the photo gets a green rim
 * and a soft pop — so you can see at a glance who's talking. */
.cs-avatar-wrap.is-speaking .cs-ring {
  border-width: 2px;
  border-color: rgba(37, 211, 102, 0.6);
  animation: csSpeakWave 1.4s ease-out infinite;
}
.cs-avatar-wrap.is-speaking .cs-ring:nth-child(2) { animation-delay: 0.46s; }
.cs-avatar-wrap.is-speaking .cs-ring:nth-child(3) { animation-delay: 0.92s; }
.cs-avatar-wrap.is-speaking .cs-avatar,
.cs-avatar-wrap.is-speaking .cs-avatar--fallback {
  box-shadow:
    0 12px 40px rgba(0, 0, 0, 0.5),
    0 0 0 3px rgba(37, 211, 102, 0.95),
    0 0 22px 2px rgba(37, 211, 102, 0.55);
  animation: csSpeakPop 0.85s ease-in-out infinite;
}

.cs-avatar,
.cs-avatar--fallback {
  position: relative;
  width: 112px;
  height: 112px;
  border-radius: 50%;
  object-fit: cover;
  box-shadow:
    0 12px 40px rgba(0, 0, 0, 0.5),
    0 0 0 1px rgba(255, 255, 255, 0.08);
}

.cs-avatar--fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.7rem;
  font-weight: 600;
  color: #ffffff;
  background: linear-gradient(145deg, #25d366, #0d9488);
}

/* ── Controls ─────────────────────────────────────────────────────────── */
.cs-controls {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 0.45rem;
  width: 100%;
  padding: 0 0.1rem;
}

/* Each control is an equal-width column so 2, 3, or 4 of them always fit the
 * window without the edge labels ("Mute" / "Minimize") clipping off-screen. */
.cs-control {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.55rem;
}

.cs-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 54px;
  flex-shrink: 0;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.14);
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.35);
  transition: transform 0.16s ease, background 0.16s ease, filter 0.16s ease;
}
.cs-btn:hover { transform: translateY(-3px); filter: brightness(1.08); }
.cs-btn:active { transform: translateY(-1px) scale(0.96); }
.cs-btn:focus-visible { outline: 3px solid rgba(255, 255, 255, 0.65); outline-offset: 3px; }

.cs-btn svg { width: 24px; height: 24px; }

.cs-btn--accept { background: #25d366; }
.cs-btn--accept:hover { background: #25d366; }
.cs-btn--decline,
.cs-btn--end { background: #ef4444; }
.cs-btn--decline:hover,
.cs-btn--end:hover { background: #ef4444; }
.cs-btn--muted { background: #ffffff; color: #0b141a; }
.cs-btn--muted:hover { background: #ffffff; color: #0b141a; }

/* Accept + decline gently breathe to pull the eye on an incoming call. */
.cs-btn--accept { animation: csAcceptPulse 1.7s ease-in-out infinite; }

.cs-control-label {
  font-size: 0.74rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.62);
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ── Group-call tile grid ─────────────────────────────────────────────── */
.cs-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: center;
  margin-top: 16px;
}

.cs-tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.cs-tile-name {
  margin-top: 6px;
  font-size: 0.82rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Tile-level status line (smaller than the main .cs-status). */
.cs-tile-state {
  font-size: 0.68rem;
  margin-bottom: 0;
}

/* Tile avatar-wrap is smaller than the single-peer wrap. */
.cs-tile .cs-avatar-wrap {
  width: 56px;
  height: 56px;
}

.cs-tile .cs-ring {
  width: 56px;
  height: 56px;
}

.cs-tile .cs-avatar,
.cs-tile .cs-avatar--fallback {
  width: 56px;
  height: 56px;
}

.cs-tile .cs-avatar--fallback {
  font-size: 1.4rem;
}

/* ── Minimized pill ───────────────────────────────────────────────────── */
.cs-pill {
  position: fixed;
  bottom: 1.25rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9998;
  display: flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.3rem 0.35rem 0.3rem 0.55rem;
  border-radius: 999px;
  color: #ffffff;
  background: linear-gradient(135deg, #2a3942, #131f26);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(12px);
  animation: csPillIn 0.26s ease-out;
  /* Draggable surface: grab cursor + no text-select/scroll while dragging. */
  cursor: grab;
  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
}
.cs-pill:active { cursor: grabbing; }

.cs-pill__id {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  cursor: inherit;
  background: transparent;
  border: none;
  color: inherit;
  padding: 0;
}

.cs-pill__avatar,
.cs-pill__avatar--fallback {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}
.cs-pill__avatar--fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.82rem;
  font-weight: 600;
  background: rgba(37, 211, 102, 0.32);
}

.cs-pill__text { display: flex; flex-direction: column; line-height: 1.15; text-align: left; }
.cs-pill__name { font-size: 0.78rem; font-weight: 600; max-width: 140px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.cs-pill__status { font-size: 0.68rem; color: rgba(255, 255, 255, 0.78); font-variant-numeric: tabular-nums; }

.cs-pill__btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.16);
  flex-shrink: 0;
  transition: background 0.15s ease, transform 0.15s ease;
}
.cs-pill__btn:hover { background: rgba(255, 255, 255, 0.28); transform: translateY(-1px); }
.cs-pill__btn svg { width: 15px; height: 15px; }
.cs-pill__btn--muted { background: #ffffff; color: #0b141a; }
.cs-pill__btn--end { background: #ef4444; }
.cs-pill__btn--end:hover { background: #ef4444; filter: brightness(1.08); }
.cs-pill__btn--accept { background: #25d366; }
.cs-pill__btn--accept:hover { background: #25d366; filter: brightness(1.08); }

/* ── Call recording: consent notice + REC badge ───────────────────────── */
.cs-rec {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  margin-left: 0.55rem;
  padding: 0.08rem 0.45rem;
  border-radius: 999px;
  font-size: 0.66rem;
  font-weight: 700;
  letter-spacing: 0.8px;
  line-height: 1.4;
  vertical-align: middle;
  color: #ffffff;
  background: #dc2626;
}
.cs-rec--compact {
  margin-left: 0.35rem;
  padding: 0 0.35rem;
  font-size: 0.58rem;
}
.cs-rec__dot {
  width: 0.42rem;
  height: 0.42rem;
  border-radius: 50%;
  flex-shrink: 0;
  background: currentColor;
  animation: csRecPulse 1.4s ease-in-out infinite;
}
.cs-rec-notice {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  max-width: 260px;
  margin: -0.5rem 0 0.9rem;
  padding: 0.55rem 0.8rem;
  border-radius: 12px;
  text-align: center;
  background: rgba(255, 255, 255, 0.08);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1);
}
.cs-rec-notice__title {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: #ffffff;
}
.cs-rec-notice__title .cs-rec__dot { color: #ef4444; }
.cs-rec-notice__body {
  font-size: 0.72rem;
  line-height: 1.35;
  color: rgba(255, 255, 255, 0.7);
}
/* "During call" recording: a participant starts it by hand. */
.cs-rec-start {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  margin: -0.5rem 0 0.9rem;
  padding: 0.45rem 0.9rem;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  font-size: 0.78rem;
  font-weight: 600;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.14);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.14);
  transition: background 0.16s ease, transform 0.16s ease;
}
.cs-rec-start:hover { background: rgba(255, 255, 255, 0.22); }
.cs-rec-start:active { transform: scale(0.97); }
.cs-rec-start:focus-visible { outline: 3px solid rgba(255, 255, 255, 0.65); outline-offset: 3px; }
.cs-rec-start:disabled { opacity: 0.6; cursor: default; }
.cs-rec-start .cs-rec__dot { color: #ef4444; animation: none; }

/* ── Keyframes ────────────────────────────────────────────────────────── */
@keyframes csFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
@keyframes csWindowIn {
  from { transform: translateY(14px) scale(0.96); opacity: 0; }
  to { transform: translateY(0) scale(1); opacity: 1; }
}
@keyframes csRingPulse {
  0% { transform: scale(0.92); opacity: 0.7; }
  80% { opacity: 0; }
  100% { transform: scale(1.45); opacity: 0; }
}
@keyframes csBreathe {
  0%, 100% { transform: scale(0.96); opacity: 0.45; }
  50% { transform: scale(1.08); opacity: 0.8; }
}
@keyframes csSpeakWave {
  0% { transform: scale(0.96); opacity: 0.7; }
  100% { transform: scale(1.55); opacity: 0; }
}
@keyframes csSpeakPop {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.045); }
}
@keyframes csAcceptPulse {
  0%, 100% { box-shadow: 0 8px 22px rgba(0, 0, 0, 0.35), 0 0 0 0 rgba(37, 211, 102, 0.45); }
  50% { box-shadow: 0 8px 22px rgba(0, 0, 0, 0.35), 0 0 0 13px rgba(37, 211, 102, 0); }
}
@keyframes csDots {
  0% { content: ''; }
  25% { content: '.'; }
  50% { content: '..'; }
  75% { content: '...'; }
  100% { content: ''; }
}
@keyframes csRecPulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.25; }
}
@keyframes csPillIn {
  from { transform: translate(-50%, 20px); opacity: 0; }
  to { transform: translate(-50%, 0); opacity: 1; }
}

/* Respect reduced-motion: drop the looping animations, keep the layout. */
@media (prefers-reduced-motion: reduce) {
  .cs-overlay,
  .cs-window,
  .cs-avatar-wrap.is-ringing .cs-ring,
  .cs-avatar-wrap.is-connected .cs-ring:first-child,
  .cs-avatar-wrap.is-speaking .cs-ring,
  .cs-avatar-wrap.is-speaking .cs-avatar,
  .cs-avatar-wrap.is-speaking .cs-avatar--fallback,
  .cs-btn--accept,
  .cs-pill,
  .cs-rec__dot,
  .cs-dots::after {
    animation: none;
  }
  .cs-avatar-wrap.is-ringing .cs-ring { opacity: 0.35; }
  /* Keep a static green rim so the speaker is still identifiable. */
  .cs-avatar-wrap.is-speaking .cs-avatar,
  .cs-avatar-wrap.is-speaking .cs-avatar--fallback {
    box-shadow:
      0 12px 40px rgba(0, 0, 0, 0.5),
      0 0 0 3px rgba(37, 211, 102, 0.95);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/call/call.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF,6EAA6E;AAC7E;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd;;kEAEgE;EAChE;;uCAEqC;EACrC,gBAAgB;EAChB,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,gDAAgD;AAChD;EACE,WAAW;EACX,6CAA6C;AAC/C;;AAEA,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,2CAA2C;EAC3C,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,sEAAsE;AACxE;AACA,mDAAmD,qBAAqB,EAAE;AAC1E,mDAAmD,qBAAqB,EAAE;AAC1E,6CAA6C;AAC7C;EACE,UAAU;EACV,uCAAuC;EACvC,8CAA8C;AAChD;;AAEA;+DAC+D;AAC/D;EACE,iBAAiB;EACjB,qCAAqC;EACrC,6CAA6C;AAC/C;AACA,oDAAoD,sBAAsB,EAAE;AAC5E,oDAAoD,sBAAsB,EAAE;AAC5E;;EAEE;;;yCAGuC;EACvC,gDAAgD;AAClD;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB;;uCAEqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qDAAqD;AACvD;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;8EAC8E;AAC9E;EACE,SAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,qCAAqC;EACrC,0CAA0C;EAC1C,0EAA0E;AAC5E;AACA,gBAAgB,2BAA2B,EAAE,wBAAwB,EAAE;AACvE,iBAAiB,uCAAuC,EAAE;AAC1D,wBAAwB,4CAA4C,EAAE,mBAAmB,EAAE;;AAE3F,cAAc,WAAW,EAAE,YAAY,EAAE;;AAEzC,kBAAkB,mBAAmB,EAAE;AACvC,wBAAwB,mBAAmB,EAAE;AAC7C;eACe,mBAAmB,EAAE;AACpC;qBACqB,mBAAmB,EAAE;AAC1C,iBAAiB,mBAAmB,EAAE,cAAc,EAAE;AACtD,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;;AAE5D,yEAAyE;AACzE,kBAAkB,kDAAkD,EAAE;;AAEtE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,2DAA2D;AAC3D;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA,4EAA4E;AAC5E;EACE,eAAe;EACf,eAAe;EACf,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sCAAsC;EACtC,oBAAoB;EACpB,cAAc;EACd,qDAAqD;EACrD,0CAA0C;EAE1C,2BAA2B;EAC3B,kCAAkC;EAClC,2EAA2E;EAC3E,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA,kBAAkB,gBAAgB,EAAE;;AAEpC;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC7F,iBAAiB,kBAAkB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACzI,mBAAmB,kBAAkB,EAAE,gCAAgC,EAAE,kCAAkC,EAAE;;AAE7G;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,qCAAqC;EACrC,cAAc;EACd,uDAAuD;AACzD;AACA,sBAAsB,qCAAqC,EAAE,2BAA2B,EAAE;AAC1F,oBAAoB,WAAW,EAAE,YAAY,EAAE;AAC/C,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,qBAAqB,mBAAmB,EAAE;AAC1C,2BAA2B,mBAAmB,EAAE,wBAAwB,EAAE;AAC1E,wBAAwB,mBAAmB,EAAE;AAC7C,8BAA8B,mBAAmB,EAAE,wBAAwB,EAAE;;AAE7E,4EAA4E;AAC5E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,wBAAwB;EACxB,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,oDAAoD;AACtD;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA,qCAAqC,cAAc,EAAE;AACrD;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;AACjC;AACA,8DAA8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,qDAAqD;EACrD,uDAAuD;AACzD;AACA,sBAAsB,qCAAqC,EAAE;AAC7D,uBAAuB,sBAAsB,EAAE;AAC/C,8BAA8B,4CAA4C,EAAE,mBAAmB,EAAE;AACjG,yBAAyB,YAAY,EAAE,eAAe,EAAE;AACxD,6BAA6B,cAAc,EAAE,eAAe,EAAE;;AAE9D,4EAA4E;AAC5E;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;AACA;EACE,OAAO,uCAAuC,EAAE,UAAU,EAAE;EAC5D,KAAK,iCAAiC,EAAE,UAAU,EAAE;AACtD;AACA;EACE,KAAK,sBAAsB,EAAE,YAAY,EAAE;EAC3C,MAAM,UAAU,EAAE;EAClB,OAAO,sBAAsB,EAAE,UAAU,EAAE;AAC7C;AACA;EACE,WAAW,sBAAsB,EAAE,aAAa,EAAE;EAClD,MAAM,sBAAsB,EAAE,YAAY,EAAE;AAC9C;AACA;EACE,KAAK,sBAAsB,EAAE,YAAY,EAAE;EAC3C,OAAO,sBAAsB,EAAE,UAAU,EAAE;AAC7C;AACA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,uBAAuB,EAAE;AACjC;AACA;EACE,WAAW,4EAA4E,EAAE;EACzF,MAAM,4EAA4E,EAAE;AACtF;AACA;EACE,KAAK,WAAW,EAAE;EAClB,MAAM,YAAY,EAAE;EACpB,MAAM,aAAa,EAAE;EACrB,MAAM,cAAc,EAAE;EACtB,OAAO,WAAW,EAAE;AACtB;AACA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,aAAa,EAAE;AACvB;AACA;EACE,OAAO,gCAAgC,EAAE,UAAU,EAAE;EACrD,KAAK,6BAA6B,EAAE,UAAU,EAAE;AAClD;;AAEA,0EAA0E;AAC1E;EACE;;;;;;;;;;;IAWE,eAAe;EACjB;EACA,sCAAsC,aAAa,EAAE;EACrD,kEAAkE;EAClE;;IAEE;;wCAEoC;EACtC;AACF","sourcesContent":["/*\n * Voice-call UI — clean, WhatsApp-style call screen. Own stylesheet (imported by\n * CallScreen) so it hot-reloads cleanly in dev and stays self-contained. Dark,\n * neutral surface with the layout: name → \"audio call\" subtitle → round photo →\n * red/green actions at the bottom. Reads well over any app theme.\n */\n\n/* ── Light backdrop; the call window floats in the TOP-RIGHT (WhatsApp) ── */\n.cs-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-end;\n  padding: 1.1rem 1.1rem 0 0;\n  background: rgba(7, 12, 15, 0.32);\n  animation: csFadeIn 0.22s ease-out;\n}\n\n/* The floating card itself — compact WhatsApp-style call window, top-right. */\n.cs-window {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  width: min(90vw, 336px);\n  min-height: 440px;\n  padding: 2rem 1.25rem 1.75rem;\n  border-radius: 22px;\n  color: #ffffff;\n  background:\n    radial-gradient(480px 340px at 50% 16%, rgba(37, 211, 102, 0.12), transparent 62%),\n    linear-gradient(180deg, #2a3942 0%, #131f26 52%, #0b141a 100%);\n  box-shadow:\n    0 24px 60px rgba(0, 0, 0, 0.55),\n    0 0 0 1px rgba(255, 255, 255, 0.06);\n  overflow: hidden;\n  animation: csWindowIn 0.26s cubic-bezier(0.22, 0.61, 0.36, 1);\n}\n\n.cs-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.55rem;\n  text-align: center;\n  padding: 0 0.5rem;\n}\n\n/* ── Name + subtitle (above the photo, WhatsApp order) ────────────────── */\n.cs-name {\n  font-size: 1.35rem;\n  font-weight: 700;\n  letter-spacing: 0.2px;\n  line-height: 1.25;\n  color: #ffffff;\n  max-width: 100%;\n}\n\n.cs-status {\n  font-size: 0.9rem;\n  font-weight: 400;\n  color: rgba(255, 255, 255, 0.62);\n  min-height: 1.3em;\n  margin-bottom: 1.1rem;\n}\n\n.cs-timer {\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 1px;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n/* Animated \"…\" for ringing/connecting states. */\n.cs-dots::after {\n  content: '';\n  animation: csDots 1.4s steps(4, end) infinite;\n}\n\n/* ── Avatar + soft pulse ──────────────────────────────────────────────── */\n.cs-avatar-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 112px;\n  height: 112px;\n  margin-top: 0.25rem;\n}\n\n.cs-ring {\n  position: absolute;\n  width: 112px;\n  height: 112px;\n  border-radius: 50%;\n  border: 1.5px solid rgba(37, 211, 102, 0.5);\n  opacity: 0;\n  pointer-events: none;\n}\n.cs-avatar-wrap.is-ringing .cs-ring {\n  animation: csRingPulse 2.6s cubic-bezier(0.22, 0.61, 0.36, 1) infinite;\n}\n.cs-avatar-wrap.is-ringing .cs-ring:nth-child(2) { animation-delay: 0.9s; }\n.cs-avatar-wrap.is-ringing .cs-ring:nth-child(3) { animation-delay: 1.8s; }\n/* Connected: a single calm breathing halo. */\n.cs-avatar-wrap.is-connected .cs-ring:first-child {\n  opacity: 1;\n  border-color: rgba(255, 255, 255, 0.16);\n  animation: csBreathe 3.6s ease-in-out infinite;\n}\n\n/* Speaking: energetic green waves ripple outward + the photo gets a green rim\n * and a soft pop — so you can see at a glance who's talking. */\n.cs-avatar-wrap.is-speaking .cs-ring {\n  border-width: 2px;\n  border-color: rgba(37, 211, 102, 0.6);\n  animation: csSpeakWave 1.4s ease-out infinite;\n}\n.cs-avatar-wrap.is-speaking .cs-ring:nth-child(2) { animation-delay: 0.46s; }\n.cs-avatar-wrap.is-speaking .cs-ring:nth-child(3) { animation-delay: 0.92s; }\n.cs-avatar-wrap.is-speaking .cs-avatar,\n.cs-avatar-wrap.is-speaking .cs-avatar--fallback {\n  box-shadow:\n    0 12px 40px rgba(0, 0, 0, 0.5),\n    0 0 0 3px rgba(37, 211, 102, 0.95),\n    0 0 22px 2px rgba(37, 211, 102, 0.55);\n  animation: csSpeakPop 0.85s ease-in-out infinite;\n}\n\n.cs-avatar,\n.cs-avatar--fallback {\n  position: relative;\n  width: 112px;\n  height: 112px;\n  border-radius: 50%;\n  object-fit: cover;\n  box-shadow:\n    0 12px 40px rgba(0, 0, 0, 0.5),\n    0 0 0 1px rgba(255, 255, 255, 0.08);\n}\n\n.cs-avatar--fallback {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 2.7rem;\n  font-weight: 600;\n  color: #ffffff;\n  background: linear-gradient(145deg, #25d366, #0d9488);\n}\n\n/* ── Controls ─────────────────────────────────────────────────────────── */\n.cs-controls {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 0.45rem;\n  width: 100%;\n  padding: 0 0.1rem;\n}\n\n/* Each control is an equal-width column so 2, 3, or 4 of them always fit the\n * window without the edge labels (\"Mute\" / \"Minimize\") clipping off-screen. */\n.cs-control {\n  flex: 1 1 0;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.55rem;\n}\n\n.cs-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 54px;\n  height: 54px;\n  flex-shrink: 0;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.14);\n  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.35);\n  transition: transform 0.16s ease, background 0.16s ease, filter 0.16s ease;\n}\n.cs-btn:hover { transform: translateY(-3px); filter: brightness(1.08); }\n.cs-btn:active { transform: translateY(-1px) scale(0.96); }\n.cs-btn:focus-visible { outline: 3px solid rgba(255, 255, 255, 0.65); outline-offset: 3px; }\n\n.cs-btn svg { width: 24px; height: 24px; }\n\n.cs-btn--accept { background: #25d366; }\n.cs-btn--accept:hover { background: #25d366; }\n.cs-btn--decline,\n.cs-btn--end { background: #ef4444; }\n.cs-btn--decline:hover,\n.cs-btn--end:hover { background: #ef4444; }\n.cs-btn--muted { background: #ffffff; color: #0b141a; }\n.cs-btn--muted:hover { background: #ffffff; color: #0b141a; }\n\n/* Accept + decline gently breathe to pull the eye on an incoming call. */\n.cs-btn--accept { animation: csAcceptPulse 1.7s ease-in-out infinite; }\n\n.cs-control-label {\n  font-size: 0.74rem;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.62);\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* ── Group-call tile grid ─────────────────────────────────────────────── */\n.cs-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  justify-content: center;\n  margin-top: 16px;\n}\n\n.cs-tile {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.cs-tile-name {\n  margin-top: 6px;\n  font-size: 0.82rem;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.9);\n  max-width: 80px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Tile-level status line (smaller than the main .cs-status). */\n.cs-tile-state {\n  font-size: 0.68rem;\n  margin-bottom: 0;\n}\n\n/* Tile avatar-wrap is smaller than the single-peer wrap. */\n.cs-tile .cs-avatar-wrap {\n  width: 56px;\n  height: 56px;\n}\n\n.cs-tile .cs-ring {\n  width: 56px;\n  height: 56px;\n}\n\n.cs-tile .cs-avatar,\n.cs-tile .cs-avatar--fallback {\n  width: 56px;\n  height: 56px;\n}\n\n.cs-tile .cs-avatar--fallback {\n  font-size: 1.4rem;\n}\n\n/* ── Minimized pill ───────────────────────────────────────────────────── */\n.cs-pill {\n  position: fixed;\n  bottom: 1.25rem;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 9998;\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  padding: 0.3rem 0.35rem 0.3rem 0.55rem;\n  border-radius: 999px;\n  color: #ffffff;\n  background: linear-gradient(135deg, #2a3942, #131f26);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45);\n  -webkit-backdrop-filter: blur(12px);\n  backdrop-filter: blur(12px);\n  animation: csPillIn 0.26s ease-out;\n  /* Draggable surface: grab cursor + no text-select/scroll while dragging. */\n  cursor: grab;\n  touch-action: none;\n  user-select: none;\n  -webkit-user-select: none;\n}\n.cs-pill:active { cursor: grabbing; }\n\n.cs-pill__id {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  cursor: inherit;\n  background: transparent;\n  border: none;\n  color: inherit;\n  padding: 0;\n}\n\n.cs-pill__avatar,\n.cs-pill__avatar--fallback {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n.cs-pill__avatar--fallback {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.82rem;\n  font-weight: 600;\n  background: rgba(37, 211, 102, 0.32);\n}\n\n.cs-pill__text { display: flex; flex-direction: column; line-height: 1.15; text-align: left; }\n.cs-pill__name { font-size: 0.78rem; font-weight: 600; max-width: 140px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.cs-pill__status { font-size: 0.68rem; color: rgba(255, 255, 255, 0.78); font-variant-numeric: tabular-nums; }\n\n.cs-pill__btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.16);\n  flex-shrink: 0;\n  transition: background 0.15s ease, transform 0.15s ease;\n}\n.cs-pill__btn:hover { background: rgba(255, 255, 255, 0.28); transform: translateY(-1px); }\n.cs-pill__btn svg { width: 15px; height: 15px; }\n.cs-pill__btn--muted { background: #ffffff; color: #0b141a; }\n.cs-pill__btn--end { background: #ef4444; }\n.cs-pill__btn--end:hover { background: #ef4444; filter: brightness(1.08); }\n.cs-pill__btn--accept { background: #25d366; }\n.cs-pill__btn--accept:hover { background: #25d366; filter: brightness(1.08); }\n\n/* ── Call recording: consent notice + REC badge ───────────────────────── */\n.cs-rec {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  margin-left: 0.55rem;\n  padding: 0.08rem 0.45rem;\n  border-radius: 999px;\n  font-size: 0.66rem;\n  font-weight: 700;\n  letter-spacing: 0.8px;\n  line-height: 1.4;\n  vertical-align: middle;\n  color: #ffffff;\n  background: #dc2626;\n}\n.cs-rec--compact {\n  margin-left: 0.35rem;\n  padding: 0 0.35rem;\n  font-size: 0.58rem;\n}\n.cs-rec__dot {\n  width: 0.42rem;\n  height: 0.42rem;\n  border-radius: 50%;\n  flex-shrink: 0;\n  background: currentColor;\n  animation: csRecPulse 1.4s ease-in-out infinite;\n}\n.cs-rec-notice {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  max-width: 260px;\n  margin: -0.5rem 0 0.9rem;\n  padding: 0.55rem 0.8rem;\n  border-radius: 12px;\n  text-align: center;\n  background: rgba(255, 255, 255, 0.08);\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1);\n}\n.cs-rec-notice__title {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #ffffff;\n}\n.cs-rec-notice__title .cs-rec__dot { color: #ef4444; }\n.cs-rec-notice__body {\n  font-size: 0.72rem;\n  line-height: 1.35;\n  color: rgba(255, 255, 255, 0.7);\n}\n/* \"During call\" recording: a participant starts it by hand. */\n.cs-rec-start {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  margin: -0.5rem 0 0.9rem;\n  padding: 0.45rem 0.9rem;\n  border: none;\n  border-radius: 999px;\n  cursor: pointer;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.14);\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.14);\n  transition: background 0.16s ease, transform 0.16s ease;\n}\n.cs-rec-start:hover { background: rgba(255, 255, 255, 0.22); }\n.cs-rec-start:active { transform: scale(0.97); }\n.cs-rec-start:focus-visible { outline: 3px solid rgba(255, 255, 255, 0.65); outline-offset: 3px; }\n.cs-rec-start:disabled { opacity: 0.6; cursor: default; }\n.cs-rec-start .cs-rec__dot { color: #ef4444; animation: none; }\n\n/* ── Keyframes ────────────────────────────────────────────────────────── */\n@keyframes csFadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n@keyframes csWindowIn {\n  from { transform: translateY(14px) scale(0.96); opacity: 0; }\n  to { transform: translateY(0) scale(1); opacity: 1; }\n}\n@keyframes csRingPulse {\n  0% { transform: scale(0.92); opacity: 0.7; }\n  80% { opacity: 0; }\n  100% { transform: scale(1.45); opacity: 0; }\n}\n@keyframes csBreathe {\n  0%, 100% { transform: scale(0.96); opacity: 0.45; }\n  50% { transform: scale(1.08); opacity: 0.8; }\n}\n@keyframes csSpeakWave {\n  0% { transform: scale(0.96); opacity: 0.7; }\n  100% { transform: scale(1.55); opacity: 0; }\n}\n@keyframes csSpeakPop {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.045); }\n}\n@keyframes csAcceptPulse {\n  0%, 100% { box-shadow: 0 8px 22px rgba(0, 0, 0, 0.35), 0 0 0 0 rgba(37, 211, 102, 0.45); }\n  50% { box-shadow: 0 8px 22px rgba(0, 0, 0, 0.35), 0 0 0 13px rgba(37, 211, 102, 0); }\n}\n@keyframes csDots {\n  0% { content: ''; }\n  25% { content: '.'; }\n  50% { content: '..'; }\n  75% { content: '...'; }\n  100% { content: ''; }\n}\n@keyframes csRecPulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.25; }\n}\n@keyframes csPillIn {\n  from { transform: translate(-50%, 20px); opacity: 0; }\n  to { transform: translate(-50%, 0); opacity: 1; }\n}\n\n/* Respect reduced-motion: drop the looping animations, keep the layout. */\n@media (prefers-reduced-motion: reduce) {\n  .cs-overlay,\n  .cs-window,\n  .cs-avatar-wrap.is-ringing .cs-ring,\n  .cs-avatar-wrap.is-connected .cs-ring:first-child,\n  .cs-avatar-wrap.is-speaking .cs-ring,\n  .cs-avatar-wrap.is-speaking .cs-avatar,\n  .cs-avatar-wrap.is-speaking .cs-avatar--fallback,\n  .cs-btn--accept,\n  .cs-pill,\n  .cs-rec__dot,\n  .cs-dots::after {\n    animation: none;\n  }\n  .cs-avatar-wrap.is-ringing .cs-ring { opacity: 0.35; }\n  /* Keep a static green rim so the speaker is still identifiable. */\n  .cs-avatar-wrap.is-speaking .cs-avatar,\n  .cs-avatar-wrap.is-speaking .cs-avatar--fallback {\n    box-shadow:\n      0 12px 40px rgba(0, 0, 0, 0.5),\n      0 0 0 3px rgba(37, 211, 102, 0.95);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
